(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const motion = () => !reduced.matches && document.body.dataset.lnMotion !== 'false' && !document.body.classList.contains('ln-motion-paused');
  const clockNodes = new Set();
  const dailyClock = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Warsaw', hourCycle: 'h23',
    hour: '2-digit', minute: '2-digit', second: '2-digit'
  });
  function dailySeconds(now) {
    const parts = Object.fromEntries(dailyClock.formatToParts(now).map(part => [part.type, part.value]));
    return 86400 - (Number(parts.hour) * 3600 + Number(parts.minute) * 60 + Number(parts.second));
  }
  function tick() {
    const seconds = dailySeconds(Date.now());
    clockNodes.forEach(node => {
      if (!node.isConnected) { clockNodes.delete(node); return; }
      node.hidden = false;
      const values = {hours: Math.floor(seconds / 3600), minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60};
      Object.entries(values).forEach(([key, value]) => {
        const el = node.querySelector(`[data-clock="${key}"]`);
        const text = String(value).padStart(2, '0');
        if (el && el.textContent !== text) el.textContent = text;
      });
    });
  }
  function enhance(root = document) {
    root.querySelectorAll('[data-ln-countdown]').forEach(node => clockNodes.add(node));
    tick();
    root.querySelectorAll('[data-ln-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const tabs = Array.from(gallery.querySelectorAll('[data-ln-thumb]'));
      const select = button => {
        gallery.querySelectorAll('[data-ln-panel]').forEach(panel => { panel.hidden = panel.dataset.lnPanel !== button.dataset.lnThumb; });
        tabs.forEach(tab => tab.setAttribute('aria-pressed', String(tab === button)));
      };
      tabs.forEach((button, index) => {
        button.addEventListener('click', () => select(button));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          tabs[next].focus(); select(tabs[next]);
        });
      });
    });
    root.querySelectorAll('[data-ln-product]').forEach(product => {
      if (product.dataset.bundleReady) return;
      const form = product.querySelector('.ln-product-form');
      const quantity = form?.querySelector('[name="quantity"]');
      const variantInput = form?.querySelector('[name="id"]');
      const json = product.closest('.shopify-section')?.querySelector('[data-ln-variants]');
      if (!quantity || !variantInput || !json) return;
      const variants = JSON.parse(json.textContent);
      const formatter = new Intl.NumberFormat(product.dataset.locale || 'pl', {style: 'currency', currency: product.dataset.currency || 'PLN'});
      const money = cents => formatter.format(cents / 100);
      const radios = Array.from(product.querySelectorAll('[data-ln-pack]'));
      const update = () => {
        const variant = variants.find(v => String(v.id) === variantInput.value) || variants[0];
        const count = Math.max(1, Math.floor(Number(quantity.value) || 1));
        const units = count * 4;
        const few = units % 10 >= 2 && units % 10 <= 4 && !(units % 100 >= 12 && units % 100 <= 14);
        const pieces = ((few ? product.dataset.piecesFew : product.dataset.piecesLabel) || '__COUNT__').replace('__COUNT__', String(units));
        radios.forEach(radio => { radio.checked = Number(radio.value) === count; });
        product.querySelectorAll('[data-ln-pack-price]').forEach(el => { el.textContent = money(variant.price * Number(el.dataset.lnPackPrice)); });
        product.querySelector('[data-ln-price]').textContent = money(variant.price);
        product.querySelector('[data-ln-total]').textContent = money(variant.price * count);
        product.querySelector('[data-ln-total-pieces]').textContent = pieces;
        const section = product.closest('.shopify-section');
        const stickyTotal = section.querySelector('[data-ln-sticky-total]');
        const stickyPieces = section.querySelector('[data-ln-sticky-pieces]');
        if (stickyTotal) stickyTotal.textContent = money(variant.price * count);
        if (stickyPieces) stickyPieces.textContent = pieces;
        const compare = product.querySelector('[data-ln-compare]');
        const sale = product.querySelector('[data-ln-sale]');
        if (compare) { compare.hidden = !(variant.compare_at_price > variant.price); compare.textContent = money(variant.compare_at_price || 0); }
        if (sale) { sale.hidden = !(variant.compare_at_price > variant.price); sale.textContent = `−${Math.round((1 - variant.price / variant.compare_at_price) * 100)}%`; }
      };
      radios.forEach(radio => radio.addEventListener('change', () => { if (radio.checked) { quantity.value = radio.value; update(); } }));
      quantity.addEventListener('input', update);
      quantity.addEventListener('change', () => { quantity.value = String(Math.max(1, Math.floor(Number(quantity.value) || 1))); update(); });
      window.addEventListener('pageshow', () => requestAnimationFrame(update));
      variantInput.addEventListener('change', update);
      product.dataset.bundleReady = 'true';
      update();
    });
    root.querySelectorAll('[data-ln-go-buy]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const chooser = document.querySelector('[data-ln-bundles]');
        if (!chooser) return;
        chooser.scrollIntoView({behavior: motion() ? 'smooth' : 'instant', block:'center'});
        chooser.querySelector('input:checked')?.focus({preventScroll:true});
      });
    });
    root.querySelectorAll('[data-ln-menu]').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
    });
    root.querySelectorAll('[data-ln-motion-toggle]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const paused = document.body.classList.toggle('ln-motion-paused');
        document.querySelectorAll('[data-ln-motion-toggle]').forEach(control => {
          control.setAttribute('aria-pressed', String(paused));
          control.setAttribute('aria-label', paused ? control.dataset.playLabel : control.dataset.pauseLabel);
          control.firstElementChild.textContent = paused ? '▷' : 'Ⅱ';
        });
      });
    });
    if ('IntersectionObserver' in window) {
      const primary = root.querySelector('[data-ln-primary-buy]');
      const sticky = root.querySelector('[data-ln-sticky]');
      if (primary && sticky && !sticky.dataset.ready) {
        sticky.dataset.ready = 'true';
        const observer = new IntersectionObserver(entries => {
          if (!primary.isConnected) { observer.disconnect(); return; }
          const entry = entries[0];
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, {threshold:0});
        observer.observe(primary);
      }
      if (motion()) {
        const observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) { if (motion()) entry.target.classList.add('ln-reveal-enter'); observer.unobserve(entry.target); }
        }), {rootMargin:'0px 0px -30px 0px',threshold:0.08});
        root.querySelectorAll('[data-ln-reveal]').forEach(el => {
          if (el.dataset.revealReady) return;
          el.dataset.revealReady = 'true';
          if (el.getBoundingClientRect().top > window.innerHeight) observer.observe(el);
        });
      }
    }
  }
  let frame = 0;
  function progress() {
    frame = 0;
    const total = document.documentElement.scrollHeight - window.innerHeight;
    document.querySelectorAll('[data-ln-progress]').forEach(el => { el.style.transform = `scaleX(${total > 0 ? Math.max(0, Math.min(1, window.scrollY / total)) : 0})`; });
  }
  window.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(progress); }, {passive:true});
  window.addEventListener('resize', progress, {passive:true});
  document.addEventListener('DOMContentLoaded', () => { enhance(); progress(); });
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  document.addEventListener('visibilitychange', () => { if (!document.hidden) tick(); });
  setInterval(() => { if (!document.hidden && clockNodes.size) tick(); }, 1000);
})();
